import Delegations from  'common/domain/models/delegations';

class FoodBenefitDelegations extends Delegations{
  constructor() {
    super();
    this.type = '';
  }

  getType() {
    return this.type;
  }
}

export default FoodBenefitDelegations;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/models/delegations.js